import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Add,
  AttachFileOutlined,
  CheckOutlined,
  FiberManualRecord,
  GetAppOutlined,
} from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";

import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";

import moment from "moment";
import { theme } from "../../../theme/theme";
import { LoadingButton } from "@mui/lab";
import { toast } from "sonner";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { useDispatch } from "react-redux";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useSelector } from "react-redux";
import { useLazyGetChannelsQuery } from "../../../features/api_channel_setup/channel/channelApi";
import { useLazyGetCategoryQuery } from "../../../features/api masterlist/category_api/categoryApi";
import { useLazyGetSubCategoryArrayQuery } from "../../../features/api masterlist/sub_category_api/subCategoryApi";
import {
  useDeleteRequestorAttachmentMutation,
  useEditRequestorConcernMutation,
} from "../../../features/api_request/concerns/concernApi";
import { useLazyGetReceiverAttachmentQuery } from "../../../features/api_request/concerns_receiver/concernReceiverApi";
import {
  useLazyGetDownloadAttachmentQuery,
  useLazyGetViewAttachmentQuery,
} from "../../../features/api_attachments/attachmentsApi";
import { notificationApi } from "../../../features/api_notification/notificationApi";
import { notificationMessageApi } from "../../../features/api_notification_message/notificationMessageApi";
import AssignDialogMenuAction from "../../Request/ReceiverConcernV2/AssignDialogMenuAction";
import { getAttachmentIcon } from "../../../utils/getAttachmentIcon";

const schema = yup.object().shape({
  Concern: yup
    .string()
    .min(2, "Concern must be more than 1 character long")
    .required("This field is required")
    .label("Ticket Details"),
  RequestAttachmentsFiles: yup.array().nullable(),

  ChannelId: yup.object().notRequired(),
  CategoryId: yup.array(),
  SubCategoryId: yup.array(),
  TargetDate: yup.date().notRequired(),
  IssueHandler: yup.string().notRequired(),
});

const RejectDateDialog = ({ data, open, onClose }) => {
  const [attachments, setAttachments] = useState([]);
  const [ticketAttachmentId, setTicketAttachmentId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [formClosed, setFormClosed] = useState(false);

  const userId = useSelector((state) => state?.user?.id);
  const userDetails = useSelector((state) => state?.user);

  const [viewIsLoading, setViewIsLoading] = useState(false);
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);

  const dispatch = useDispatch();
  const fileInputRef = useRef();
  // useSignalRConnection();

  const [getChannel, { data: channelData, isLoading: channelIsLoading, isSuccess: channelIsSuccess }] =
    useLazyGetChannelsQuery();
  const [getCategory, { data: categoryData, isLoading: categoryIsLoading, isSuccess: categoryIsSuccess }] =
    useLazyGetCategoryQuery();
  const [
    getSubCategory,
    { data: subCategoryData, isLoading: subCategoryIsLoading, isSuccess: subCategoryIsSuccess },
  ] = useLazyGetSubCategoryArrayQuery();
  const [
    createEditReceiverConcern,
    { isLoading: isCreateEditReceiverConcernLoading, isFetching: isCreateEditReceiverConcernFetching },
  ] = useEditRequestorConcernMutation();
  // const [smsNotification] = useSendSmsNotificationMutation();

  const [deleteRequestorAttachment] = useDeleteRequestorAttachmentMutation();
  const [getAddReceiverAttachment] = useLazyGetReceiverAttachmentQuery();
  const [getViewAttachment] = useLazyGetViewAttachmentQuery();
  const [getDownloadAttachment] = useLazyGetDownloadAttachmentQuery();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      Concern: "",
      RequestAttachmentsFiles: [],

      ChannelId: null,
      CategoryId: [],
      SubCategoryId: [],
      TargetDate: null,
      IssueHandler: userId,
    },
  });

  const handleAttachments = (event) => {
    const newFiles = Array.from(event.target.files);

    const fileNames = newFiles.map((file) => ({
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2),
      file,
    }));

    const uniqueNewFiles = fileNames?.filter(
      (newFile) => !attachments?.some((existingFile) => existingFile?.name === newFile?.name),
    );
    setAttachments((prevFiles) =>
      Array.isArray(prevFiles) ? [...prevFiles, ...uniqueNewFiles] : [...uniqueNewFiles],
    );
  };

  const handleUploadButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleDeleteFile = async (fileNameToDelete) => {
    try {
      if (fileNameToDelete.ticketAttachmentId) {
        const deletePayload = {
          ticketAttachmentId: fileNameToDelete.ticketAttachmentId,
        };
        await deleteRequestorAttachment(deletePayload).unwrap();
      }
      setAttachments((prevFiles) => prevFiles.filter((fileName) => fileName !== fileNameToDelete));

      setValue(
        "RequestAttachmentsFiles",
        watch("RequestAttachmentsFiles").filter((file) => file.name !== fileNameToDelete.name),
      );
    } catch (error) {}
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const getAddAttachmentData = async (id) => {
    try {
      const res = await getAddReceiverAttachment({ Id: id }).unwrap();

      setAttachments(
        res?.value?.[0]?.attachments?.map((item) => ({
          ticketAttachmentId: item.ticketAttachmentId,
          name: item.fileName,
          size: (item.fileSize / (1024 * 1024)).toFixed(2),
          link: item.attachment,
        })),
      );
    } catch (error) {}
  };

  const handleViewImage = async (file) => {
    console.log("View File:", file);

    setViewIsLoading(true);
    try {
      const response = await getViewAttachment(file?.ticketAttachmentId);

      if (response?.data) {
        const imageUrl = URL.createObjectURL(response.data); // Create a URL for the fetched image
        setSelectedImage(imageUrl); // Set the image URL to state
        setIsViewDialogOpen(true);
        setViewIsLoading(false);
      }
      setViewIsLoading(false);
    } catch (error) {
      console.error("Error fetching image:", error);
      toast.error("Error!", {
        description: "View file error!",
        duration: 1500,
      });
      setViewIsLoading(false);
    }
  };

  const handleViewImageWithoutId = (file) => {
    setViewIsLoading(true);
    try {
      const reader = new FileReader();

      reader.onload = (e) => {
        setSelectedImage(e.target.result);
        setIsViewDialogOpen(true);
      };
      reader.readAsDataURL(file);
      setViewIsLoading(false);
    } catch (error) {
      console.error("Error fetching image:", error);

      toast.error("Error!", {
        description: "View file error!",
        duration: 1500,
      });
      setViewIsLoading(false);
    }
  };

  const isImageFile = (fileName) => {
    return /\.(jpg|jpeg|png)$/i.test(fileName);
  };

  const handleDownloadAttachment = async (file) => {
    setDownloadIsLoading(true);
    try {
      const response = await getDownloadAttachment(file?.ticketAttachmentId);

      if (response?.data) {
        const blob = new Blob([response.data], { type: response.data.type });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${file?.name || "attachment"}`); // Default to 'attachment' if no name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up after download
        setDownloadIsLoading(false);
      } else {
        console.log("No data in the response");
      }
    } catch (error) {
      console.log("Error", error);
      toast.error("Error!", {
        description: "Download file error!",
        duration: 1500,
      });
      setDownloadIsLoading(false);
    }
  };

  const onCloseAction = () => {
    reset();
    setFormClosed((prev) => !prev);
    onClose();
  };

  const handleViewImageClose = () => {
    setIsViewDialogOpen(false);
    setSelectedImage(null);
  };

  const onSubmitAction = (formData) => {
    const payload = new FormData();

    payload.append("RequestConcernId", formData?.RequestConcernId);
    payload.append("TicketConcernId", data?.ticketConcernId);
    payload.append("Request_Type", data?.request_Type);
    payload.append("Severity", data?.severity);
    payload.append("BackJobId", data?.backJobId === null ? "" : data?.backJobId);
    payload.append("UserId", data?.requestor_By);
    payload.append("Contact_Number", data?.contact_Number === null ? "" : data?.contact_Number);

    payload.append("ServiceProviderId", data?.serviceProviderId);
    payload.append("DateNeeded", data.date_Needed ? moment(data.date_Needed).format("YYYY-MM-DD") : "");
    payload.append("Notes", data?.notes === null ? "" : data?.notes);

    payload.append("ChannelId", formData.ChannelId ? formData.ChannelId?.channelId : 0);
    payload.append("TargetDate", moment(formData.TargetDate).format("YYYY-MM-DD"));
    payload.append("AssignTo", formData.IssueHandler ? formData.IssueHandler : "");
    payload.append("Concern", formData.Concern);

    const category = formData.CategoryId;
    for (let i = 0; i < category.length; i++) {
      payload.append(`AddRequestTicketCategory[${i}].ticketCategoryId`, category[i].ticketCategoryId || "");
      payload.append(`AddRequestTicketCategory[${i}].categoryId`, category[i]?.id);
    }

    if (category.length === 0) {
      payload.append(`AddRequestTicketCategory[0].ticketCategoryId`, "");
      payload.append(`AddRequestTicketCategory[0].categoryId`, "");
    }

    const subCategory = formData.SubCategoryId;
    for (let i = 0; i < subCategory.length; i++) {
      payload.append(
        `AddRequestTicketSubCategory[${i}].ticketSubCategoryId`,
        subCategory[i].ticketSubCategoryId || "",
      );
      payload.append(`AddRequestTicketSubCategory[${i}].subCategoryId`, subCategory[i]?.subCategoryId);
    }

    if (subCategory.length === 0) {
      payload.append(`AddRequestTicketSubCategory[0].ticketSubCategoryId`, "");
      payload.append(`AddRequestTicketSubCategory[0].subCategoryId`, "");
    }

    const files = formData.RequestAttachmentsFiles;
    for (let i = 0; i < files.length; i++) {
      payload.append(`RequestAttachmentsFile[${i}].ticketAttachmentId`, files[i].ticketAttachmentId || "");
      payload.append(`RequestAttachmentsFile[${i}].attachment`, files[i]);
    }

    if (files.length === 0) {
      payload.append(`RequestAttachmentsFile[0].ticketAttachmentId`, "");
      payload.append(`RequestAttachmentsFile[0].attachment`, "");
    }

    // console.log("Payload Entries: ", [...payload.entries()]);

    // const smsPayload = {
    //   system_name: "Make It Simple",
    //   message: `Fresh Morning! Concern #${data?.requestConcernId} has been assigned to your account. Kindly check your ticket list.`,
    //   mobile_number: data?.contact_Number,
    // };

    Swal.fire({
      title: "Confirmation",
      text: `Are you sure you want to save changes to ticket ${moment(data?.created_At).format("YYYY")}-${data?.ticketConcernId}?`,
      icon: "info",
      color: "white",
      showCancelButton: true,
      background: "#111927",
      confirmButtonColor: "#9e77ed",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      cancelButtonColor: "#1C2536",
      heightAuto: false,
      width: "30em",
      customClass: {
        container: "custom-container",
        title: "custom-title",
        htmlContainer: "custom-text",
        icon: "custom-icon",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        createEditReceiverConcern(payload)
          .unwrap()
          .then((response) => {
            toast.success("Success!", {
              description: "Ticket updated successfully!",
              duration: 1500,
            });

            dispatch(notificationApi.util.resetApiState());
            dispatch(notificationMessageApi.util.resetApiState());

            setAttachments([]);
            reset();
            onClose();
          })
          .catch((err) => {
            console.log("Error", err);
            toast.error("Error!", {
              description: err.data.error.message,
              duration: 1500,
            });
          });

        // SEND SMS STATUS
        // try {
        //   smsNotification(smsPayload).unwrap();
        // } catch (error) {
        //   console.log(error);
        //   toast.error("Error!", {
        //     description: "Sms notification error!",
        //     duration: 1500,
        //   });
        // }
      }
    });
  };

  useEffect(() => {
    if (data) {
      if (!channelIsSuccess) getChannel();

      setValue("Concern", data?.concern_Description);
      setValue("RequestConcernId", data?.requestConcernId);

      if (data?.channelId !== null) {
        setValue("ChannelId", {
          channelId: data?.channelId,
          channelName: data?.channel_Name,
        });
      } else {
        setValue("ChannelId", null);
      }

      const category = data?.getOpenTicketCategories?.map((item) => ({
        ticketCategoryId: item.ticketCategoryId,
        id: item.categoryId,
        category_Description: item.category_Description,
      }));

      const subCategory = data?.getOpenTicketSubCategories?.map((item) => ({
        ticketSubCategoryId: item.ticketSubCategoryId,
        subCategoryId: item.subCategoryId,
        sub_Category_Description: item.subCategory_Description,
      }));

      const categoryIdParams = data?.getOpenTicketCategories?.map((item) => item?.categoryId);

      setValue("CategoryId", category);
      setValue("SubCategoryId", subCategory);

      //   setValue("TargetDate", data?.targetDate ? moment(data?.targetDate) : null);

      getAddAttachmentData(data?.ticketConcernId);
      getSubCategory({
        CategoryId: categoryIdParams,
      });
    }
  }, [data, formClosed]);

  useEffect(() => {
    const selectedCategories = watch("CategoryId");
    const selectedSubCategories = watch("SubCategoryId");

    if (selectedCategories.length > 0) {
      const filteredSubCategories = selectedSubCategories.filter((subCategory) =>
        selectedCategories.some((category) =>
          subCategoryData?.value?.some(
            (item) => item.subCategoryId === subCategory.subCategoryId && item.categoryId === category.id,
          ),
        ),
      );
      setValue("SubCategoryId", filteredSubCategories);
    } else {
      setValue("SubCategoryId", []);
    }
  }, [subCategoryData]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            event.stopPropagation();
            return;
          }
          onCloseAction();
        }}
        disableEscapeKeyDown={false}
        sx={{ borderRadius: "none", padding: 0, backdropFilter: "blur(5px)" }}
        PaperProps={{ style: { overflow: "auto" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 0,
            paddingBottom: 0,
            marginBlockEnd: "5.28px",
            fontSize: "18px",
            fontWeight: 700,
            color: theme.palette.success.main,
          }}
        >
          Ticket Details
        </DialogTitle>

        <Stack sx={{ width: "100%", height: "auto", mb: 4, borderRadius: "20px", padding: 2 }}>
          <form onSubmit={handleSubmit(onSubmitAction)}>
            <DialogContent>
              <Stack sx={{ width: "100%", height: "auto", gap: 2 }}>
                <Stack sx={{ width: "100%", gap: 0.5, mb: 1 }}>
                  <Stack direction="row" gap={6}>
                    <Box sx={{ width: "110px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Ticket No:
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "13px",
                        }}
                      >
                        {`${moment(data?.created_At).format("YYYY")}-${data?.ticketConcernId}`}
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack direction="row" gap={6}>
                    <Box sx={{ width: "110px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Date Needed:
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "13px",
                        }}
                      >
                        {data?.date_Needed ? moment(data?.date_Needed).format("LL") : "-"}
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack direction="row" gap={6}>
                    <Box sx={{ width: "110px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Service Provider:
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "13px",
                        }}
                      >
                        {data?.serviceProviderName}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Channel
                    </Typography>
                    <FiberManualRecord color="error" sx={{ fontSize: "10px" }} />
                  </Stack>

                  <Controller
                    control={control}
                    name="ChannelId"
                    render={({ field: { ref, value, onChange } }) => {
                      return (
                        <Autocomplete
                          ref={ref}
                          size="small"
                          value={value}
                          options={userDetails?.channels || []}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Channel Name"
                              sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
                            />
                          )}
                          onChange={(_, value) => {
                            onChange(value);
                            setValue("CategoryId", []);
                            setValue("SubCategoryId", []);
                            setValue("userId", null);
                          }}
                          getOptionLabel={(option) => option.channelName || ""}
                          isOptionEqualToValue={(option, value) => option.channelId === value.channelId}
                          sx={{
                            flex: 2,
                          }}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-listbox": {
                                  fontSize: "13px",
                                },
                              },
                            },
                          }}
                          fullWidth
                          disableClearable
                          disabled
                        />
                      );
                    }}
                  />
                </Stack>

                <Stack>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Category
                    </Typography>
                    <FiberManualRecord color="error" sx={{ fontSize: "10px" }} />
                  </Stack>

                  <Controller
                    control={control}
                    name="CategoryId"
                    render={({ field: { ref, value, onChange } }) => {
                      return (
                        <Autocomplete
                          multiple
                          ref={ref}
                          size="small"
                          value={value}
                          options={
                            categoryData?.value?.category?.filter(
                              (item) => item.channelId === watch("ChannelId")?.channelId,
                            ) || []
                          }
                          loading={categoryIsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Category"
                              sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
                            />
                          )}
                          onOpen={() => {
                            if (!categoryIsSuccess)
                              getCategory({
                                Status: true,
                              });
                          }}
                          onChange={(_, value) => {
                            onChange(value);
                            const categoryIdParams = value?.map((category) => category?.id);
                            if (watch("CategoryId").length === 0) {
                              setValue("SubCategoryId", []);
                            }
                            getSubCategory({
                              CategoryId: categoryIdParams,
                            });
                          }}
                          getOptionLabel={(option) => option.category_Description || ""}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionDisabled={(option) =>
                            watch("CategoryId").some((item) => item.id === option.id)
                          }
                          sx={{
                            flex: 2,
                          }}
                          fullWidth
                          // disablePortal
                          disableClearable
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-listbox": {
                                  fontSize: "13px",
                                },
                              },
                            },
                          }}
                        />
                      );
                    }}
                  />
                </Stack>

                <Stack>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Sub Category
                    </Typography>
                    <FiberManualRecord color="error" sx={{ fontSize: "10px" }} />
                  </Stack>

                  <Controller
                    control={control}
                    name="SubCategoryId"
                    render={({ field: { ref, value, onChange } }) => {
                      return (
                        <Autocomplete
                          multiple
                          ref={ref}
                          size="small"
                          value={value}
                          options={subCategoryData?.value || []}
                          loading={subCategoryIsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Sub Category"
                              sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
                            />
                          )}
                          onOpen={() => {
                            if (!subCategoryIsSuccess) getSubCategory();
                          }}
                          onChange={(_, value) => {
                            onChange(value);
                          }}
                          getOptionLabel={(option) => option?.sub_Category_Description || ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.subCategoryId === value?.subCategoryId
                          }
                          getOptionDisabled={(option) =>
                            watch("SubCategoryId").some((item) => item.subCategoryId === option.subCategoryId)
                          }
                          noOptionsText={"No sub category available"}
                          sx={{
                            flex: 2,
                          }}
                          fullWidth
                          // disablePortal
                          disableClearable
                          disabled={!watch("ChannelId")}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-listbox": {
                                  fontSize: "13px",
                                },
                              },
                            },
                          }}
                        />
                      );
                    }}
                  />
                </Stack>

                <Stack>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Target Date
                    </Typography>
                    <FiberManualRecord color="error" sx={{ fontSize: "10px" }} />
                  </Stack>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Controller
                      control={control}
                      name="TargetDate"
                      render={({ field }) => (
                        <DatePicker
                          value={field.value ? moment(field.value) : null}
                          onChange={(newValue) => {
                            const formattedValue = newValue ? moment(newValue).format("YYYY-MM-DD") : null;
                            field.onChange(formattedValue);
                          }}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              sx: {
                                "& .MuiInputBase-input": {
                                  padding: "10.5px 14px",
                                },
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "13px",
                                },
                              },
                            },
                          }}
                          minDate={new moment()}
                          error={!!errors.targetDate}
                          helperText={errors.targetDate ? errors.targetDate.message : null}
                        />
                      )}
                    />
                    {errors.targetDate && <Typography>{errors.targetDate.message}</Typography>}
                  </LocalizationProvider>
                </Stack>

                <Stack gap={0.5}>
                  <Typography
                    sx={{
                      fontSize: "13px",
                    }}
                  >
                    Ticket Description
                  </Typography>
                  <Controller
                    control={control}
                    name="Concern"
                    render={({ field: { ref, value, onChange } }) => {
                      return (
                        <TextField
                          inputRef={ref}
                          size="small"
                          value={value}
                          placeholder="Description"
                          onChange={onChange}
                          error={!!errors.Concern}
                          sx={{
                            width: "100%",
                          }}
                          InputProps={{
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          InputLabelProps={{
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          autoComplete="off"
                          rows={6}
                          multiline
                          disabled
                        />
                      );
                    }}
                  />
                  {errors.Concern && (
                    <Typography color="error" sx={{ fontSize: "12px" }}>
                      {errors.Concern.message}
                    </Typography>
                  )}
                </Stack>

                {/* Attachments */}
                <Stack
                  padding={2}
                  marginTop={3}
                  gap={1.5}
                  sx={{ border: "1px solid #2D3748", borderRadius: "20px" }}
                >
                  <Stack direction="row" gap={1} alignItems="center" onDragOver={handleDragOver}>
                    <GetAppOutlined sx={{ color: theme.palette.text.secondary }} />

                    <Typography
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      Attachments:
                    </Typography>

                    <Button
                      size="sm"
                      variant="contained"
                      color="warning"
                      startIcon={<Add sx={{ fontSize: "15px" }} />}
                      onClick={handleUploadButtonClick}
                      sx={{ borderRadius: "1px" }}
                    >
                      <Typography sx={{ fontSize: "11px" }}>Add</Typography>
                    </Button>
                  </Stack>

                  {attachments === undefined ? (
                    <Stack sx={{ flexDirection: "column", maxHeight: "auto" }}>
                      <Stack direction="row" gap={0.5} justifyContent="center">
                        <AttachFileOutlined sx={{ color: theme.palette.text.secondary }} />
                        <Typography sx={{ color: theme.palette.text.secondary }}>No attached file</Typography>
                      </Stack>
                    </Stack>
                  ) : (
                    <Stack sx={{ flexDirection: "column", maxHeight: "auto" }}>
                      {attachments?.map((fileName, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            padding: 1,
                          }}
                        >
                          {getAttachmentIcon(fileName)}
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: 0.5,
                              borderBottom: "1px solid #2D3748",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography sx={{ fontSize: "14px" }}>{fileName.name}</Typography>

                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: theme.palette.text.secondary,
                                }}
                              >
                                {fileName.size} Mb
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: !!fileName.ticketAttachmentId
                                      ? theme.palette.success.main
                                      : theme.palette.primary.main,
                                  }}
                                >
                                  {!!fileName.ticketAttachmentId
                                    ? "Attached file"
                                    : "Uploaded the file successfully"}
                                </Typography>

                                {!!fileName.ticketAttachmentId && (
                                  <CheckOutlined color="success" fontSize="small" />
                                )}
                              </Box>
                            </Box>

                            <Box>
                              <AssignDialogMenuAction
                                fileName={fileName}
                                onView={handleViewImage}
                                onViewWithoutId={handleViewImageWithoutId}
                                onDelete={handleDeleteFile}
                                onDownload={handleDownloadAttachment}
                                isImageFile={isImageFile}
                                viewIsLoading={viewIsLoading}
                                downloadIsLoading={downloadIsLoading}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Stack>
                  )}
                </Stack>

                <Controller
                  control={control}
                  name="RequestAttachmentsFiles"
                  render={({ field: { onChange, value } }) => (
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".png,.jpg,.jpeg,.docx,.pdf,.xls,.xlsx"
                      onChange={(event) => {
                        if (ticketAttachmentId) {
                          const files = Array.from(event.target.files);
                          files[0].ticketAttachmentId = ticketAttachmentId;
                          onChange([
                            ...files,
                            ...value.filter((item) => item.ticketAttachmentId !== ticketAttachmentId),
                          ]);

                          setAttachments((prevFiles) => [
                            ...prevFiles.filter((item) => item.ticketAttachmentId !== ticketAttachmentId),
                            {
                              ticketAttachmentId: ticketAttachmentId,
                              name: files[0].name,
                              size: (files[0].size / (1024 * 1024)).toFixed(2),
                            },
                          ]);

                          fileInputRef.current.value = "";
                          setTicketAttachmentId(null);
                        } else {
                          handleAttachments(event);
                          const files = Array.from(event.target.files);

                          const uniqueNewFiles = files.filter(
                            (item) => !value.some((file) => file.name === item.name),
                          );

                          onChange([...value, ...uniqueNewFiles]);
                          fileInputRef.current.value = "";
                        }
                      }}
                      hidden
                      multiple={!!ticketAttachmentId}
                    />
                  )}
                />
              </Stack>
            </DialogContent>

            <DialogActions>
              <LoadingButton variant="outlined" onClick={onCloseAction} size="small">
                Cancel
              </LoadingButton>
              <LoadingButton
                size="small"
                type="submit"
                variant="contained"
                loading={isCreateEditReceiverConcernLoading || isCreateEditReceiverConcernFetching}
                disabled={
                  !watch("ChannelId") ||
                  watch("CategoryId").length === 0 ||
                  watch("SubCategoryId").length === 0 ||
                  !watch("IssueHandler") ||
                  !watch("TargetDate")
                }
                sx={{
                  ":disabled": {
                    backgroundColor: theme.palette.secondary.main,
                    color: "black",
                  },
                }}
              >
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        </Stack>

        {/* Dialog to view image */}
        {selectedImage && (
          <>
            <Dialog fullWidth maxWidth="md" open={isViewDialogOpen} onClose={handleViewImageClose}>
              <DialogContent sx={{ height: "auto" }}>
                {selectedImage && <img src={selectedImage} alt="Preview" style={{ width: "100%" }} />}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleViewImageClose}>Close</Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Dialog>
    </>
  );
};

export default RejectDateDialog;
